<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Offer Images</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container margin_60_35">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-9">
            <div class="isotope-wrapper">
              <div class="row">
                <div class="box_general padding_bottom">
                  <MultiUpload
                    apiPath="/offer/createOfferImages"
                    :transId="offerId"
                  />

                  <table class="table datatable" width="100%">
                    <thead>
                      <th>Sr no</th>
                      <th>Image</th>
                      <th>Is Default</th>
                      <th>Action</th>
                    </thead>
                    <tbody>
                      <tr v-for="(image, index) in offerImages" :key="image.id">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <img
                            :src="
                              'https://peekzy.in/backend/public/assets/uploads/offer-images/' +
                              image.image
                            "
                            style="max-height: 100px"
                          />
                        </td>
                        <td>
                          <i
                            class="fa fa-close alert-danger"
                            v-if="image.is_default == 0"
                          ></i
                          ><i class="fa fa-check alert-success" v-else></i>
                        </td>
                        <td>
                          <i
                            class="fa fa-trash"
                            v-if="image.is_active == 1"
                            @click.prevent="remove(image.id, 0)"
                          ></i
                          ><i
                            class="fa fa-arrow-return-left"
                            v-else
                            @click.prevent="remove(image.id, 1)"
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import API from "@/services/index.js";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import MultiUpload from "@/cmps/MultiUpload.vue";
export default {
  data() {
    //alert(localStorage.getItem("pincode"));
    return {
      loading: false,
      token: "Bearer " + localStorage.getItem("token"),
      location: localStorage.getItem("location"),
      pincode: localStorage.getItem("pincode"),
      offerId: this.$route.params.id,
      offerImages: null,
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    MultiUpload,
  },
  beforeMount() {
    this.checkToken();
    this.getOfferimages();
  },

  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
    getOfferimages() {
      API.get("offer/getOfferImages/" + this.offerId, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          this.offerImages = res.data.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    remove(imageId, status) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      //this.$swal.showloader();
      const formData = new FormData();
      formData.append("is_active", status);
      API.post("/offer/removeOfferImage/" + imageId, formData, {
        headers: { Authorization: this.token },
      }).then((res) => {
        if (res.data.status == 200) {
          Toast.fire({
            icon: "success",
            title: res.data.messages,
          });
          window.location.reload();
        } else {
          let error = JSON.stringify(res.data.messages);
          Toast.fire({
            icon: "error",
            title: error,
          });
        }
      });
    },
  },
};
</script>

<style  scoped>
.category > label {
  margin: 0px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>